import useTranslate from "hooks/useTranslate";
import Arrow from "assets/icons/arrowDown.svg?react";
import "./styles.sass";

type BackButtonProps = {
  handleClick: () => void;
};

const BackButton = ({ handleClick }: BackButtonProps) => {
  const t = useTranslate();

  return (
    <button className="BackButton" type="button" onClick={handleClick}>
      <Arrow className="BackButton__arrow" />
      <span>{t("tournament.view.back")}</span>
    </button>
  );
};

export default BackButton;
